import Logger from './../Logger.js';
import PublicEvent from './PublicEvent.js';

class StopYouTubeEvent extends PublicEvent {
  handle(msg) {
    this.context._api
      .stopBroadcast('youtube')
      .then(() => super.handle({ type: msg.type }))
      .catch(error => Logger.warn(error));
  }
}

export default StopYouTubeEvent;
